import { render, staticRenderFns } from "./operationsManagement.vue?vue&type=template&id=c262a7bc&scoped=true"
import script from "./operationsManagement.vue?vue&type=script&lang=js"
export * from "./operationsManagement.vue?vue&type=script&lang=js"
import style0 from "./operationsManagement.vue?vue&type=style&index=0&id=c262a7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c262a7bc",
  null
  
)

export default component.exports